import { qbHttp } from "./http";

export const listProductTypes = () => qbHttp.request("api/qb/product-types");

export const getProductType = (id) =>
  qbHttp.request(`api/qb/product-types/${id}`);

export const createProductType = (body) =>
  qbHttp.request("api/qb/product-types", { method: "POST", body });

export const updateProductType = (id, body) =>
  qbHttp.request(`api/qb/product-types/${id}`, { method: "PUT", body });

export const deleteProductType = (id) =>
  qbHttp.request(`api/qb/product-types/${id}`, { method: "DELETE" });
